export default "__VITE_ASSET__6HXWVMx1N5zM4qBF8KUwkw__"